import { createSelector } from '@reduxjs/toolkit';
import { AppState } from '../types';

const selectCommonState = (state: AppState) => state.common;

/** A selector that returns the device's current network state. Note that this is always `unknown` on web. */
export const selectNetworkState = createSelector(selectCommonState, state => state.networkState);

/** A selector that returns whether or not the side menu is open. */
export const selectSideMenuOpen = createSelector(selectCommonState, state => state.sideMenuOpen);
